<template>
  <div class="public_bg">
    <div class="nurse_top">
      <div style="height: 54px; line-height: 54px">
        <img
          style="vertical-align: middle"
          src="@/assets/beadhouse/juxing.png"
        />
        <span>物资管理</span>
      </div>
    </div>
    <div class="row_link clearfix">
      <div
        class="item"
        v-for="(item, index) in infoList"
        :key="index"
        @click="handleClick(item.uid)"
      >
        <a>
          <img :src="item.img" />
          <h5 style="font-size: 16px">{{ item.title }}</h5>
          <span>{{ item.text }}</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  data() {
    return {
      infoList: [], //数据源
    };
  },
  methods: {
    //点击每个
    handleClick(id) {
      console.log(id);
      switch (id) {
        case 0:
          bus.$emit("homePage", {
            type: "jump",
            path: "/StorageCatalogManage",
            title: "物资项目管理",
          });
        break;
        case 1:
          bus.$emit("homePage", {
            type: "jump",
            path: "/StorageStockManage",
            title: "物资库存表",
          });
        break;
        case 2:
          bus.$emit("homePage", {
            type: "jump",
            path: "/StorageInTable",
            title: "物资入库表",
          });
        break;
        case 3:
          bus.$emit("homePage", {
            type: "jump",
            path: "/StorageOutTable",
            title: "物资出库表",
          });
        break;
        case 5:
          bus.$emit("homePage", {
            type: "jump",
            path: "/WuZiResign",
            title: "物资消杀登记",
          });
        break;
      }
    },
    /**
     * 获取菜单栏的数据列表
     */
    getPageData() {
      this.infoList = [
        {
          img:require("@/assets/beadhouse/xt_cwgl.png"),
          title:'物资项目管理',
          text:'管理物资的仓库及项目',
          uid:0,
          url:'/StorageCatalogManage'
        },
        {
          img:require("@/assets/beadhouse/cardlist.png"),
          title:'物资库存表',
          text:'查看物资仓库的库存情况',
          uid:1,
          url:'/StorageStockManage'
        },
        {
          img:require("@/assets/beadhouse/accessEvent.png"),
          title:'物资入库表',
          text:'物资的进出记录登记',
          uid:2,
          url:'/StorageInTable'
        },
        {
          img:require("@/assets/beadhouse/jiaobanrizhi.png"),
          title:'物资出库表',
          text:'物资的进出记录登记',
          uid:3,
          url:'/StorageOutTable'
        },
        {
          img:require("@/assets/beadhouse/banzhangrizhi.png"),
          title:'物资消杀登记',
          text:'物资的进入消杀的记录登记',
          uid:5,
          url:'/WuZiResign'
        },
        
      ];
    },
  },
  created() {
    this.getPageData();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.public_bg {
  width: 100%;
  padding: 0 0 20px 0;
  height: 95%;
  background: #fefefe;
  .nurse_top {
    border: 1px #f1eff2 solid;
    background: #f9f7fa;
    position: relative;
    img {
      margin: 14px 12px;
    }
    h5 {
      display: inline-block;
      position: absolute;
      top: 12px;
      font-size: 18px;
    }
  }
  .row_link {
    width: 1259px;
    margin: 34px 35px;
    .item {
      width: 275px;
      height: 99px;
      border: #f0f0f2 1px solid;
      margin-bottom: 34px;
      margin-right: 34px;
      float: left;
      cursor: pointer;
      img {
        float: left;
        margin: 8px 23px 8px 33px;
        margin-right: 16px;
      }
      span {
        color: #666666;
      }
      h5 {
        margin-top: 21px;
        margin-bottom: 8px;
      }
      a:hover {
        color: #333;
      }
    }
    .item:hover {
      border: 1px solid red;
    }
  }
}
</style>
